import { render, staticRenderFns } from "./BasketAssign.vue?vue&type=template&id=423c8c1f&scoped=true"
import script from "./BasketAssign.vue?vue&type=script&lang=js"
export * from "./BasketAssign.vue?vue&type=script&lang=js"
import style0 from "./BasketAssign.vue?vue&type=style&index=0&id=423c8c1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423c8c1f",
  null
  
)

export default component.exports